/*
 * Copyright ThreatBlockr Inc 2025
 * ejohnson created
 */

import light from '@/plugins/vuetify/themes/themeLight'
import dark from '@/plugins/vuetify/themes/themeDark'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import Boing from '@/components/icon/Boing.vue'
import BoingSolid from '@/components/icon/BoingSolid.vue'

import SortSolid from '@/components/icon/SortSolid.vue'
import SortUpSolid from '@/components/icon/SortUpSolid.vue'
import SortDownSolid from '@/components/icon/SortDownSolid.vue'

Vue.use(Vuetify)

const vuetify = new Vuetify({
    icons: {
        iconfont: 'mdi',
        values: {
            boing: { // name of our custom icon
                component: Boing, // our custom component
            },
            boingSolid: { // name of our custom icon
                component: BoingSolid, // our custom component
            },
            sortSolid: { // name of our custom icon
                component: SortSolid, // our custom component
            },
            sortUpSolid: { // name of our custom icon
                component: SortUpSolid, // our custom component
            },
            sortDownSolid: { // name of our custom icon
                component: SortDownSolid, // our custom component
            },
        },

    },
    theme: {
        // dark: mq.matches,
        // dark: true,
        themes: {
            light: light,
            dark: dark,
        },
    },
})

export default vuetify
